import noop from 'lodash-es/noop';

// eslint-disable-next-line import/prefer-default-export
export const RATE_SMILES = (t = noop) => [
  { emoji: '😣', id: 1, title: t('horrible') },
  { emoji: '🙁', id: 2, title: t('bad') },
  { emoji: '😕', id: 3, title: t('meh') },
  { emoji: '🙂', id: 4, title: t('good') },
  { emoji: '😄', id: 5, title: t('awesome') },
];
